export default __webpack_public_path__ + "static/media/9.8041d503.jpg";